import {SOPutRelationship} from '../../core/relationship/so-put-relationship';
import {RelationshipCore} from './relationship.core';
import {SOGetRelationship} from '../../core/relationship/so-get-relationship';
import {FormField, SelectionOption} from 'lionheartland';
import {putRelationshipFormFieldOptions} from './put-relationship-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPutRelationship extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putRelationshipFormFieldOptions);

  RequestClass = SOPutRelationship

  constructor(
    public entityCore: RelationshipCore
  ) {
    super();
    if (putRelationshipFormFieldOptions.project) {
      putRelationshipFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}